import { plainToInstance, Type } from "class-transformer";
import { Node } from 'rete'
import i18n from 'vue-i18n'

import { MenuSectionNames } from '../../../../../components'
import CustomEditor from '../../../../Editor/CustomEditor'
import { BaseNodeModelData } from '../../../BaseNode/BaseNodeDataModel'
import { BaseNodeModel } from '../../../BaseNode/BaseNodeModel'
import { CustomNode, CustomNodeComponent, NodeTypes, } from '../../../index'
import SampleRandomizerNode from '../ui/node/SampleRandomizerNode.vue'
import RandomizerNodeSidebar from '../ui/sidebar/RandomizerNodeSidebar.vue'

export default class RandomizerNodeBuilder extends CustomNodeComponent {
  sidebarComponent = RandomizerNodeSidebar

  constructor(i18n: i18n) {
    super(SampleRandomizerNode, RandomizerNode, NodeTypes.Randomizer, i18n)
  }

  getBaseNodeModel = ([ x, y ]: [number, number]) => {
      return {
        data: plainToInstance(RandomizerNodeData, {
          type: NodeTypes.Randomizer,
          random: false,
          buttons: [
            { output: CustomNode.LastSocketId += 1, percent: 50 },
            { output: CustomNode.LastSocketId += 1, percent: 50 },
          ],
        }),
        input: CustomNode.LastSocketId += 1,
        color: null,
        x,
        y,
      }
  }
}

export class RandomizerNode extends CustomNode {
  data: RandomizerNodeData

  constructor(name: NodeTypes.Randomizer, struct: BaseNodeModel) {
    super(name, struct)

    if (struct.data instanceof RandomizerNodeData) {
      struct.data.buttons.forEach((b) => this.socketActions.createOutput(b.output))
      this.data = struct.data
    } else {
      throw new Error('To node come unknown data')
    }
  }

  get freePercents(): number {
    const total = this.data.buttons.map((b) => b.percent)
      .reduce((pre, cur) => pre + cur)

    return 100 - total
  }

  setButtonPercent(output: number, percent: number): void {
    const button = this.data.buttons.find((b) => b.output === output)

    if (button) {
      if (percent <= button.percent + this.freePercents) {
        button.percent = percent
      } else {
        if (this.freePercents !== 0) {
          button.percent = this.freePercents
        }
      }
    }
  }

  switchRandom(val: boolean): void {
    this.data.random = val
  }

  addRandomizerOutput(): void {
    const newButton = plainToInstance(RandomizerButton, { output: this.socketActions.createOutput(), percent: 1 })
    this.data.buttons.push(newButton)
  }

  async removeRandomizerOutput(outputId: number, editor: CustomEditor): Promise<void> {
    const buttons = this.data.buttons

    const button = buttons.find((b) => b.output === outputId)
    const output = this.outputs.get(outputId.toString())

    if (button && output) {
      buttons.splice(buttons.indexOf(button), 1)

      requestAnimationFrame(() => {
        this.removeOutput(output)
      })

      await this.update()
      editor.view.updateConnections({ node: this as unknown as Node })
    }
  }
}

export class RandomizerNodeData extends BaseNodeModelData {
  declare type: NodeTypes.Randomizer
  random!: boolean
  @Type(() => RandomizerButton)
  buttons!: Array<RandomizerButton>
}

export class RandomizerButton {
  output!: number
  percent!: number
}
